import React from 'react'
import PropTypes from 'prop-types'
import styled from '@nobia/zeus-components/lib/styled'
import Radio from './Radio'
import { useTranslation } from '../../utils/useTranslation'

const RadioContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const RadioOption = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-family: ${({ theme }) => theme.font.preamble.fontFamily};
  font-size: 15px;
  line-height: 23px;
  font-weight: 300;
  margin: 0;
`

const RadioGroup = ({ name, value, onChange, borderColor = '#bbb' }) => {
  const { t } = useTranslation('app.components.installation')

  return (
    <RadioContainer>
      <RadioOption>
        <Radio
          name={name}
          value={true}
          checked={value === true}
          handleChecked={onChange}
          borderColor={borderColor}
        />
        {t('yes')}
      </RadioOption>
      <RadioOption>
        <Radio
          name={name}
          value={false}
          checked={value === false}
          handleChecked={onChange}
          borderColor={borderColor}
        />
        {t('no')}
      </RadioOption>
    </RadioContainer>
  )
}

RadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  borderColor: PropTypes.string,
}

export default RadioGroup
